import { useShallow } from 'zustand/react/shallow';
import { useCallback } from 'react';
import { FloatingPanel } from '@mews/b2b-ui';
import { lt } from '@mews/framework';
import { Identifiable, createHandler } from '@mews/std';
import { TextKey, SearchType } from '@mews-commander/enums';
import { DialogTemplateFetcher } from '../TemplateFetcher/DialogTemplateFetcher';
import { closeNewEntityBackendDialog, useSearchNewEntityDialogBackendStore } from './store';

const getTitleFromSearchType = createHandler<SearchType, Mews.TextKey>(
    {
        [SearchType.Company]: TextKey.NewCompany,
        [SearchType.Customer]: TextKey.CustomerNew,
    },
    TextKey.Create
);

export function SearchNewEntityDialogBackendPage() {
    const store = useSearchNewEntityDialogBackendStore(useShallow((state) => state));
    const { onSuccess, searchType, url } = store || {};

    const onClose = useCallback(() => {
        closeNewEntityBackendDialog();
    }, []);

    const onFetchSuccess = useCallback(
        (data: Identifiable) => {
            onSuccess?.(data);
            onClose();
        },
        [onClose, onSuccess]
    );

    const active = !!store;
    const titleTextKey = getTitleFromSearchType(searchType);

    return (
        <FloatingPanel active={active} onClose={onClose} title={lt(titleTextKey)}>
            {url ? <DialogTemplateFetcher url={url} onFetchSuccess={onFetchSuccess} /> : null}
        </FloatingPanel>
    );
}
